import React, {useState, useEffect} from "react";
import {useSelector} from "react-redux";

//helpers:
import {useTranslation} from "react-i18next";
import {getImageFromFilesbyKey} from "../../../../_metronic/_helpers";

//components:
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import {ImagesGroup, NetgraphNavbarBadges} from "../../../widgets";

const NetgraphNavbar = ({
    filter1Selected,
    setFilter1Selected,
    dropdown1,
    showSelectorModal,
    setShowSelectorModal,
    dropdown2Type,
    selectedItemsDropdown2,
    insightsOptions,
    selectedInsights,
    setSelectedInsights,
}) => {
    const {t} = useTranslation();

    const [showFilter1Dropdown, setShowFilter1Dropdown] = useState(false);
    const [speakersImages, setSpeakersImages] = useState([]);
    const [videosImages, setVideosImages] = useState([]);
    const [topicsImages, setTopicsImages] = useState([]);

    const selectedFilter1ID = filter1Selected?.[0]?.id;
    const filter1IsSpeakers = selectedFilter1ID === "speakers";
    const filter1IsVideos = selectedFilter1ID === "videos";
    const filter1IsTopics = selectedFilter1ID === "topics";

    const isLoadingNetgraphData = useSelector(state => state.trackPage.isLoadingNetgraphData);
    const isLoadingNetgraphConfig = useSelector(state => state.trackPage.isLoadingNetgraphConfig);

    useEffect(() => {
        const hasLength = selectedItemsDropdown2?.length;
        if (hasLength) {
            if (dropdown2Type.toLowerCase() === "videos") {
                const videos = selectedItemsDropdown2?.map(video => {
                    const image = getImageFromFilesbyKey(video.files, video.id, "imgPortrait", video.type_id);
                    return {id: video.id, name: video.name, media_url: image};
                });
                setVideosImages(videos);
            } else if (dropdown2Type.toLowerCase() === "speakers") {
                setSpeakersImages(selectedItemsDropdown2);
            } else if (dropdown2Type.toLowerCase() === "topics") {
                setTopicsImages(selectedItemsDropdown2);
            }
        } else {
            setSpeakersImages([]);
            setVideosImages([]);
            setTopicsImages([]);
        }
    }, [selectedItemsDropdown2]);

    return (
        <div className="category-network-chart-top card shadow rounded p-4 gutter-b">
            <div className="d-flex flex-wrap w-100 align-items-stretch">
                {/* filter1: */}
                <div className="filter_container firstFilter">
                    <div className="d-flex flex-column px-4">
                        <span className="title">{t("TRACKPAGE.GRAPH.NAV.EXPLORE_CONTENT")}</span>
                        <div className="d-flex align-items-center pl-5 my-auto">
                            <span className="prefix">{t("TRACKPAGE.GRAPH.NAV.BY")}</span>
                            <div className="custom_underlined_select font-weight-bolder">
                                <div className="list">
                                    <div
                                        className={`d-flex align-items-center cursor-pointer ${
                                            showFilter1Dropdown ? "active_item" : "placeholder"
                                        }`}
                                        onClick={() => setShowFilter1Dropdown(!showFilter1Dropdown)}
                                    >
                                        <span className="w-fit-content">
                                            {filter1Selected?.[0]?.translatedName || ""}
                                        </span>
                                        {!showFilter1Dropdown ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
                                    </div>

                                    <ul
                                        className={` ${
                                            showFilter1Dropdown ? "show_list rounded-bottom border border-top-0" : ""
                                        }`}
                                    >
                                        {dropdown1?.map((option, i) =>
                                            option.translatedName !== filter1Selected?.[0]?.translatedName ? (
                                                <li key={i}>
                                                    <span
                                                        className="cursor-pointer"
                                                        onClick={() => {
                                                            setFilter1Selected([option]);
                                                            setShowFilter1Dropdown(false);
                                                        }}
                                                    >
                                                        {option.translatedName}
                                                    </span>
                                                </li>
                                            ) : null
                                        )}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* filter2 */}
                {selectedFilter1ID ? (
                    <>
                        <span className="horizontal_separator d-flex d-lg-none col-12" />
                        <div className="filter_container secondFilter">
                            <div className="d-none d-lg-flex separator" />
                            {filter1IsVideos ? (
                                <>
                                    <div className="d-flex flex-column px-4 w-100">
                                        <div className="title">{t("TRACKPAGE.GRAPH.NAV.PICK_VIDEOS")}</div>
                                        <div className="d-flex align-items-start my-auto">
                                            <div className="custom_underlined_select font-weight-bolder">
                                                <div className="list">
                                                    <div
                                                        className={`d-flex align-items-center ${
                                                            showSelectorModal ? "active_item" : "placeholder"
                                                        }`}
                                                    >
                                                        <ImagesGroup
                                                            isLoading={isLoadingNetgraphData || isLoadingNetgraphConfig}
                                                            type="videos"
                                                            images={videosImages}
                                                            toggleImage={() => setShowSelectorModal(true)}
                                                            placeholder={t("MODAL.VIDEOS_SELECTOR.EMPTY")}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="d-none d-lg-flex separator" />
                                </>
                            ) : filter1IsSpeakers ? (
                                <>
                                    <div className="d-flex flex-column px-4 w-100">
                                        <div className="title">{t("TRACKPAGE.GRAPH.NAV.PICK_SPEAKERS")}</div>
                                        <div className="d-flex align-items-start my-auto">
                                            <div className="custom_underlined_select font-weight-bolder">
                                                <div className="list">
                                                    <div
                                                        className={`d-flex align-items-center ${
                                                            showSelectorModal ? "active_item" : "placeholder"
                                                        }`}
                                                    >
                                                        <ImagesGroup
                                                            isLoading={isLoadingNetgraphData || isLoadingNetgraphConfig}
                                                            placeholder={t("MODAL.SPEAKERS_SELECTOR.EMPTY")}
                                                            type="speakers"
                                                            images={speakersImages}
                                                            toggleImage={() => setShowSelectorModal(true)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="d-none d-lg-flex separator" />
                                </>
                            ) : filter1IsTopics ? (
                                <div className="d-flex flex-column px-4 w-100">
                                    <div className="title">{t("TRACKPAGE.GRAPH.NAV.PICK_TOPICS")}</div>
                                    <div className="d-flex align-items-start my-auto">
                                        <div className="custom_underlined_select font-weight-bolder">
                                            <div className="list">
                                                <div
                                                    className={`d-flex align-items-center ${
                                                        showSelectorModal ? "active_item" : "placeholder"
                                                    }`}
                                                >
                                                    <ImagesGroup
                                                        isLoading={isLoadingNetgraphData || isLoadingNetgraphConfig}
                                                        placeholder={t("MODAL.TOPICS_SELECTOR.EMPTY")}
                                                        type="topics"
                                                        images={topicsImages}
                                                        toggleImage={() => setShowSelectorModal(true)}
                                                    />{" "}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : null}
                        </div>

                        {/* filter3 */}
                        {filter1IsVideos || filter1IsSpeakers ? (
                            <>
                                <span className="horizontal_separator d-flex d-lg-none col-12" />
                                <div className="filter_container thirdFilter">
                                    <div className="d-flex flex-column px-4">
                                        <div className="title">{t("TRACKPAGE.GRAPH.NAV.DISPLAY")}</div>
                                        <div className="d-flex align-items-center my-auto">
                                            <div className="d-flex mx-lg-auto pl-5">
                                                <NetgraphNavbarBadges
                                                    insightsOptions={insightsOptions}
                                                    selectedInsights={selectedInsights}
                                                    setSelectedInsights={setSelectedInsights}
                                                    className="xl"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        ) : null}
                    </>
                ) : null}
            </div>
        </div>
    );
};

export default NetgraphNavbar;
